<template>
  <div>
    <p>
      Shipped on {{ shipment.ship_dte }} via {{ shipment.service }}
      <span v-if="shipment.tracking">with <a :href="shipment.tracking_url" target="_blank">Tracking #{{shipment.tracking}}</a></span>.
    </p>
    <p v-if="shipment.delivered">Delivered {{shipment.delivered_at}}<em v-if="shipment.status_detail"> ({{shipment.status_detail}})</em>.</p>
  </div>
</template>

<style scoped>
p {
  margin: 0;
}
</style>

<script>
export default {
  props: {
      shipment: {
          type: Object,
          default: null
      },
  },
  methods: {
  }
}
</script>